function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.8047 11.1387C13.5444 11.3991 13.1223 11.3991 12.8619 11.1387L8 6.27679L3.13807 11.1387C2.87772 11.3991 2.45561 11.3991 2.19526 11.1387C1.93491 10.8784 1.93491 10.4563 2.19526 10.1959L7.5286 4.86258C7.78894 4.60223 8.21105 4.60223 8.4714 4.86258L13.8047 10.1959C14.0651 10.4563 14.0651 10.8784 13.8047 11.1387Z",
  fill: "#555555"
});

function SvgIconChevronUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronUp);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy44MDQ3IDExLjEzODdDMTMuNTQ0NCAxMS4zOTkxIDEzLjEyMjMgMTEuMzk5MSAxMi44NjE5IDExLjEzODdMOCA2LjI3Njc5TDMuMTM4MDcgMTEuMTM4N0MyLjg3NzcyIDExLjM5OTEgMi40NTU2MSAxMS4zOTkxIDIuMTk1MjYgMTEuMTM4N0MxLjkzNDkxIDEwLjg3ODQgMS45MzQ5MSAxMC40NTYzIDIuMTk1MjYgMTAuMTk1OUw3LjUyODYgNC44NjI1OEM3Ljc4ODk0IDQuNjAyMjMgOC4yMTEwNSA0LjYwMjIzIDguNDcxNCA0Ljg2MjU4TDEzLjgwNDcgMTAuMTk1OUMxNC4wNjUxIDEwLjQ1NjMgMTQuMDY1MSAxMC44Nzg0IDEzLjgwNDcgMTEuMTM4N1oiIGZpbGw9IiM1NTU1NTUiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };